import { Seo } from "@/components/Seo";
import { useLang } from "@/i18n";
import { Applications } from "@/components/Sections";

export default function ApplicationsPage() {
  const { t } = useLang();
  return (
    <>
      <Seo title={t.seo.applications.title} description={t.seo.applications.description} path="/applications" />
      <Applications h1 />
    </>
  );
}
